var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeNav1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.32993 20.7029V17.7438C9.32993 16.9884 9.94677 16.3761 10.7077 16.3761H13.4891C13.8545 16.3761 14.205 16.5202 14.4633 16.7767C14.7217 17.0332 14.8669 17.3811 14.8669 17.7438V20.7029C14.8646 21.0169 14.9886 21.3189 15.2115 21.5418C15.4344 21.7646 15.7376 21.89 16.054 21.89H17.9516C18.8379 21.8923 19.6886 21.5443 20.3161 20.923C20.9436 20.3017 21.2963 19.458 21.2963 18.5782V10.1482C21.2963 9.43753 20.9789 8.76339 20.4298 8.30741L13.9744 3.18922C12.8514 2.29183 11.2425 2.3208 10.1531 3.25804L3.845 8.30741C3.2699 8.74994 2.92617 9.42609 2.90918 10.1482V18.5696C2.90918 20.4034 4.40665 21.89 6.25386 21.89H8.10817C8.76521 21.89 9.29918 21.3637 9.30394 20.7115L9.32993 20.7029Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeNav1);
export default __webpack_public_path__ + "static/media/homeNav1.0d2cdce0ed49023752d64584910235e5.svg";
export { ForwardRef as ReactComponent };